import { render, staticRenderFns } from "./ShipperIntoMaterial.vue?vue&type=template&id=6e1214a6&scoped=true&"
import script from "./ShipperIntoMaterial.vue?vue&type=script&lang=js&"
export * from "./ShipperIntoMaterial.vue?vue&type=script&lang=js&"
import style0 from "./ShipperIntoMaterial.vue?vue&type=style&index=0&id=6e1214a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1214a6",
  null
  
)

export default component.exports